import { MessagingHelper } from "../helpers/MessagingHelper";
import { AuthDTO } from "../models/AuthDTO";
import { LoginDTO } from "../models/LoginDTO";
import { APIService } from "./APIService";

export class AuthService {

    async Login(auth: LoginDTO): Promise<MessagingHelper<AuthDTO | null>> {
        try {
            var response = await APIService.Axios().post(`${APIService.GetURL()}/auth/login`, {
                ...auth
            }, { withCredentials: true });
            return response.data;
        } catch (error) {
            return new MessagingHelper<AuthDTO | null>(false, "Erro ao fazer login", null);
        };
    }

    async GetUser(): Promise<MessagingHelper<AuthDTO | null>> {
        try {
            var response = await APIService.Axios().get(`${APIService.GetURL()}/auth/getUser`, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            return new MessagingHelper<AuthDTO | null>(false, "Erro ao obter informação do utilizador", null);
        };
    }

    async Logout(): Promise<MessagingHelper<any>> {
        try {
            var response = await APIService.Axios().post(`${APIService.GetURL()}/auth/logout`, {}, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            return new MessagingHelper<any>(false, "Erro ao fazer logout", null);
        };
    }

     async Register(register: AuthDTO): Promise<MessagingHelper<AuthDTO | null>> {
        try {
            var response = await APIService.Axios().post(`${APIService.GetURL()}/auth/register`, {
                ...register
            });
            return response.data;
        } catch (error) {
            return new MessagingHelper<AuthDTO | null>(false, "Erro ao criar utilizador", null);
        };
    }
}